import TechnologiesSection from './sections/TechnologiesSection'

export default function Technologies() {
  return <TechnologiesSection />
}
